import { i18n } from '@/i18n'
import { ActivityLogParser } from '@/parsers/activityLog'

export class AccountBalanceReportActivityLogParser extends ActivityLogParser {
    static getLogDescriptionCancelCreation (activityLog, data) {
        return i18n.tc('common.change-log.someone-cancelled-something', 1, { 'someone': data.causer, 'something': `<b>${ i18n.tc('common.change-log.action.creation', 1) }</b>` })
    }
}
